import styled from 'styled-components';
import { Box } from '../../layout/Box';
import { Flex } from '../../layout/Flex';

export const Root = styled(Box).attrs((props) => ({
    ...props,
    position: 'relative',
    width: '100%',
    overflow: 'hidden',
    as: 'article',
}))`
    -webkit-user-select: none;
    user-select: none;
    transform: translateZ(0px);
`;

export const Header = styled(Flex).attrs((props) => ({
    ...props,
    as: 'header',
    direction: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    position: 'absolute',
    top: 0,
    left: 0,
    p: 2,
    width: '100%',
    zIndex: 5,
    spacing: 1,
}))``;

export const Content = styled(Flex)
    .withConfig({ displayName: 'Content' })
    .attrs((props) => ({
        ...props,
        position: 'absolute',
        direction: 'column',
        justifyContent: 'flex-end',
        px: 1,
        pb: 1.5,
        pt: 7.5,
        bottom: 0,
        left: 0,
        width: '100%',
        zIndex: 2,
    }))``;

export const Shadow = styled(Box)
    .withConfig({ displayName: 'Shadow' })
    .attrs((props) => ({
        ...props,
        position: 'absolute',
        width: '100%',
        height: '100%',
        zIndex: 1,
        background: 'rgba(0, 0, 0, 0.70)',
        transition: '200ms linear opacity',
        cursor: 'pointer',
    }))``;
